import { render, staticRenderFns } from "./storeDisplayRecord.vue?vue&type=template&id=a05befa0"
import script from "./storeDisplayRecord.vue?vue&type=script&lang=js"
export * from "./storeDisplayRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports